<template>
  <div class="content-container">
    <!--
    <van-nav-bar>
      <template v-slot:right>
        <a @click="$router.push({name:'personal/info'})">
          <a-icon type="setting" />
        </a>
      </template>
    </van-nav-bar>
    -->
    <card>
      <template slot="body">
        <div class="account-info" style="position:relative">
          <div style="display:flex;align-items: center;">
            <img
              :src="form.avatar?form.avatar:avatar"
              class="header-avatar"
            />
            <div class="account-middle">
              <span class="phone">{{form.phone}}</span>
              <br />
              <a-tag color="#f50">{{$t('descriptions.profession')}}</a-tag>
              <span class="expire-time">{{userDetail.expire_time+$t('descriptions.expire')}}</span>
              <a-progress :percent="userDetail.progress" :show-info="false" />
              <span
                class="storage-percent"
              >{{userDetail.g_use_capacity}}G/{{userDetail.g_capacity}}G</span>
            </div>
          </div>
          <div class="account-right" @click="$router.push({name:'personal/info'})">
            <a-icon type="right" style="color:rgba(179, 179, 179, 1)" />
          </div>
          <a-button type="primary" size="small" @click="switchAccountVisible = true" style="position:absolute;right:15px;top:0;">
            {{$t('common.memberChange')}}
          </a-button> 
        </div>
      </template>
    </card>
    <div style="height: 10px"></div>
    <card :title="$t('descriptions.myTotalViews')">
      <template slot="body">
        <AreaChartCard
          ref="areaChart"
          :loading="chartLoading"
          :title="$t('charts.totalViews')"
          :chartTips="$t('charts.totalViews')"
          :total="chartData.total"
          :rightTitle="$t('charts.dayViews')"
          :rightNum="chartData.today"
          theme="#ea4856"
          uniqueId="areacontainer1"
        ></AreaChartCard>
      </template>
    </card>
    <a-row style="padding:10px">
      <a-col style="padding:5px;" :xs="8">
        <a-button  @click="$router.push({ path: '/mobile/member/work/list'})" style="height: 36px" type="primary" shape="round" block ghost>
          {{$t('moduleTitles.workManage')}}
        </a-button>
      </a-col>
      <a-col style="padding:5px;" :xs="8">
        <a-button @click="$router.push({ path: '/mobile/publish'})" type="danger" style="height: 36px" shape="round" block>
          {{$t('publish.publish')}}
        </a-button>
      </a-col>
      <a-col style="padding:5px;" :xs="8">
        <a-button @click="$router.push({ path: '/mobile/live'})" type="danger" style="height: 36px" shape="round" block>
          {{$t("moduleTitles.releaselive")}}
        </a-button>
      </a-col>
    </a-row>
    <div>
      <card :title="$t('moduleTitles.myMaterial')">
        <template slot="header-right">
          <span style="color:rgba(179, 179, 179, 1)">
            <!-- 管理
            <a-icon type="right" /> -->
          </span>
        </template>
        <template slot="body">
          <div style="padding:0 10px" v-if="materialList.length">
            <div class="content-list">
              <div
                class="content-list-item"
                v-for="item in materialList"
                :key="item.id"
                @click="$router.push({ path: '/mobile/member/material',query:{type: item.type}})"
              >
                <img :src="item.url" alt="material" />
                <span class="nav-title">{{item.title}}</span>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
    <div v-for="nav in navList" :key="nav.id" @click="$router.push({name:nav.path})">
      <card :title="nav.title">
        <template slot="header-right">
          <span style="color:rgba(179, 179, 179, 1)">
            <a-icon type="right" />
          </span>
        </template>
      </card>
    </div>
    <!--切換帳號-->
    <a-drawer
      width="80%"
      :title="$t('form.team.changeAccount')"
      placement="left"
      :visible="switchAccountVisible"
      @close="switchAccountVisible = false"
    >
      <div class="change-member-box">
          <!--        個人帳號-->
          <div>
              <label>{{$t('form.team.personal')+''+$t('form.common.field.account.label')}}</label>
              <a-row class="account-box" :gutter="12" v-if="currentAccount && Object.keys(currentAccount).length">
                  <a-col :span="24">
                      <div class="lists" @click="changeMember()">
                          <img :src="currentAccount.avatar?currentAccount.avatar:avatar"/>
                          <div class="contents">
                              <h4>{{currentAccount.name}}</h4>
                              <h5>{{currentAccount.phone}}</h5>
                          </div>
                          <span v-if="currentTeamId == 0">{{$t('form.team.currUse')}}</span>
                      </div>
                  </a-col>
              </a-row>
          </div>
          <!--        我創建的團隊-->
          <div v-if="currentAccount && currentAccount.is_team_member">
              <label>{{$t('form.team.createTeam')}}</label>
              <a-row class="account-box" :gutter="12" v-if="Object.keys(myTeam).length">
                  <a-col :span="24">
                      <div class="lists" @click="changeMember(myTeam)">
                          <img :src="myTeam.logo?myTeam.logo:avatar"/>
                          <div class="contents">
                              <h4>{{myTeam.name}}</h4>
                              <h5>{{myTeam.phone}}</h5>
                          </div>
                          <span v-if="currentTeamId == myTeam.id">{{$t('form.team.currUse')}}</span>
                      </div>
                  </a-col>
              </a-row>
              <div class="empty-box" v-else>{{$t('form.team.createMsg')}}</div>
          </div>
          <!--        我加入的團隊-->
          <div>
              <label>{{$t('form.team.joinTeam')}}</label>
              <a-row class="account-box" :gutter="12" v-if="teamList.length">
                  <a-col :span="24" v-for="item in teamList" :key="item.id">
                      <div class="lists" @click="changeMember(item)">
                          <img :src="item.logo?item.logo:avatar"/>
                          <div class="contents">
                              <h4>{{item.name}}</h4>
                              <h5>{{item.phone}}</h5>
                          </div>
                          <span v-if="currentTeamId == item.id">{{$t('form.team.currUse')}}</span>
                      </div>
                  </a-col>
              </a-row>
              <div class="empty-box" v-else>{{$t('form.team.joinMsg')}}</div>
          </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup, NavBar } from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NavBar);
import AreaChartCard from "@/components/Charts/AreaChartCard";
import Card from "../../components/Card";
import { pageQueryWork } from "@/api/work";
import { getVisitDateStatist } from "@/api/statistic";
import { mapGetters } from "vuex";
import { getUserInfo } from "@/api/user";
import {getUserTeamList, changeTeam} from "@/api/team";

export default {
  components: { AreaChartCard, Card },
  computed: {
    ...mapGetters(["userInfo"]),
    currentTeamId() {
        let id = parseInt(this.userInfo.team_id)
        return id
    }
  },
  data() {
    return {
      filters: [
        {
          text: `${this.$t("enum.workIsPublic[1]")}`,
          value: "1",
        },
        {
          text: `${this.$t("enum.workIsPublic[0]")}`,
          value: "0",
        },
      ],
      form: {
        avatar: "",
        phone: "",
        address: "",
      },
      avatar: '/ssr/static/images/default_avatar.jpg',
      chartLoading: false,
      loading: false,
      pageResult: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {
        order: {
          create_time: "desc",
          total_browse: "desc",
        },
        is_public: [],
      },
      chartData: {
        total: 0,
        today: 0,
      },
      userDetail: {expire_time: "-"},
      materialList: [
        {
          id: 1,
          url: require("@/assets/pano.jpg"),
          title: this.$t("enum.materialType.0"),
          type: 0,
        },
        {
          id: 5,
          url: require("@/assets/panovideo.jpg"),
          title: this.$t("enum.materialType.4"),
          type: 4,
        },
        {
          id: 6,
          url: require("@/assets/video.jpg"),
          title: this.$t("enum.materialType.5"),
          type: 5,
        },
        {
          id: 2,
          url: require("@/assets/image.jpg"),
          title: this.$t("enum.materialType.1"),
          type: 1,
        },
        {
          id: 3,
          url: require("@/assets/audio.jpg"),
          title: this.$t("enum.materialType.2"),
          type: 2,
        },
        {
          id: 4,
          url: require("@/assets/video.jpg"),
          title: this.$t("enum.materialType.3"),
          type: 3,
        },
        
      ],
      navList: [
        { id: 1, title: this.$t('moduleTitles.materialRecycle'), path: "mbMaterialRecycle" },
        { id: 2, title: this.$t('moduleTitles.workRecycle'), path: "mbWorkRecycle" },
      ],
      switchAccountVisible: false,
      currentAccount: null,
      myTeam: {},
      teamList: [],
      is_team_member: -1,
    };
  },
  created() {
    this.getDatas();
    this.form = this.userInfo;
    this.userInfo.expire_time = this.userInfo.expire_time.substring(0, 11);
    getUserInfo().then((res) => {
      this.userDetail = res.data;
      this.userDetail.expire_time = this.userDetail.expire_time.substring(
        0,
        11
      );
    });
    //獲取圖表數據
    getVisitDateStatist()
    .then((res) => {
      const data = res.data;
      this.chartData.total = data.total_count;
      this.chartData.today = data.today_count;
      if (data.statistics_data) {
        this.updateChartsData(data.statistics_data);
      }
    })
    .catch((err) => {
      // this.$message.error(err);
    });
    this.getUserTeamList();
  },
  methods: {
    updateChartsData(data) {
      this.$refs.areaChart.update(data);
    },
    clickToEdit() {
      this.$router.push("/member/account/basic");
    },
    getDatas() {
      this.loading = true;
      this.searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQueryWork(this.searchParam)
        .then((res) => {
          this.loading = false;
          this.pageResult = res.data;
          this.pagination.total = res.data.total;
        })
        .catch((err) => (this.loading = false));
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;

      const pager = { ...this.pagination };
      if (Object.keys(filters).length > 0) {
        this.searchParam.is_public = filters.status;
      }

      if (sorter.field === "update_time") {
        this.searchParam.order.create_time =
          sorter.order === "ascend" ? "asc" : "desc";
      }

      if (sorter.field === "total_browse") {
        this.searchParam.order.total_browse =
          sorter.order === "ascend" ? "asc" : "desc";
      }

      this.getDatas();
    },
    toTour(item) {
       const { href } = this.$router.resolve({
        path: (item.type==2 ? "/live/" : "/tour/") + `${item.uuid}`,
      });
      window.open(href, "_blank");
    },
    //獲取團隊列表
    getUserTeamList() {
        getUserTeamList().then(res => {
            const data = res.data;
            const adminTeam = data.adminTeam ? data.adminTeam : {};

            this.currentAccount = data.user_info
            this.myTeam = adminTeam
            this.teamList = data.teamList
        }).catch(err => {
            console.log(err)
        })
    },
    //切換團隊
    changeMember(item = {}) {
        const id = Object.keys(item).length ? item.id : 0
        const team_path = this.$route.path.indexOf('/member/team') != -1 ? true : false
        const project_path = this.$route.path.indexOf('/member/project') != -1 ? true : false
        console.log(project_path,this.userInfo)
        changeTeam({team_id: id}).then(res => {
            if (res.code == 1) {
                this.$message.success(res.message,1)
                this.switchAccountVisible = false
                setTimeout(() => {
                    if((team_path && id == 0) || (project_path && this.userInfo.level == 0)){
                        this.$router.push({
                            name: 'memberAccountBasic',
                            params:{change_team: 1}
                        })
                    }else{
                        window.location.reload();
                    }
                }, 1000)

            }
        }).catch(err => {
            console.log(err)
        })
    },
  },
};
</script>

<style scoped lang="less">
.content-container {
  background-color: #fff;
  min-height: 100vh;
}

.account-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
}
.card-bottom {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.header-avatar {
  margin-right: 16px;
  width: 90px;
  height: 90px;
  border-radius: 100%;
}
.account-middle {
  margin-right: 20px;
}
.phone {
  font-size: 16px;
  color: #000000;
  text-align: left;
  font-weight: bold;
  line-height: 150%;
}
.address {
  color: rgba(166, 166, 166, 1);
  font-size: 12px;
  line-height: 150%;
  text-align: left;
}
.storage-percent {
  margin-right: 10px;
  font-size: 0.7rem;
}
.expire-time {
  font-size: 0.8rem;
}
.work-name:hover {
  cursor: pointer;
  color: #1890ff;
}
.content-list {
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
  align-items: center;
  .content-list-item {
    width: 26vw;
    height: 15vw;
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
    }
    .nav-title {
      display: inline-block;
      color: #fff;
      position: absolute;
      font-size: 12px;
      width: 100%;
      text-align: center;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      text-shadow: 1px 1px 1px rgba(0,0,0,.5);
    }
  }
}
.content-list::-webkit-scrollbar {
  display: none;
}
/deep/ .card-header {
  padding: 12px 15px !important;
}
/deep/ .card-header:active {
  background-color: #f2f3f5 !important;
}
/deep/ .ant-card-body {
  padding: 0 15px !important;
}
/deep/ .info-circle {
  color: rgba(0, 0, 0, 0.45) !important;
}
/deep/ .chart-card-others {
  margin-right: 3px;
}

//切換團隊
.change-member-box {
    label {
        font-size: 14px;
        color: #000;
        margin-bottom: 15px;
        display: inline-block;
    }

    .empty-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 0;
        color: #555;
    }

    .account-box {
        .lists {
            position: relative;
            display: flex;
            align-items: center;
            padding: 15px;
            margin-bottom: 12px;
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #e8e8e8;
            box-shadow: 0 0 8px 3px rgba(0, 0, 0, .03);
            cursor: pointer;

            &:hover {
                background-color: #f9f9f9;
            }

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                flex-shrink: 0;
                margin-right: 14px;
            }

            .contents {
                h4 {
                    font-size: 14px;
                    color: #555;
                    margin-bottom: 0;
                }

                h5 {
                    font-size: 12px;
                    color: #aaa;
                    margin-bottom: 0;
                }
            }

            & > span {
                position: absolute;
                top: 0;
                right: 0;
                z-index: 10;
                padding: 4px 10px;
                background-color: #0d95e8;
                color: #fff;
                font-size: 12px;
                border-radius: 0 0 0 10px;
            }
        }
    }
}
</style>
